export default __webpack_public_path__ + "static/media/Dire Rain of Khitai.666d0945.jpg";